import React from 'react';
import { FadeIn } from './FadeIn';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './Accordion';
export function FaqSection() {
  return <section className="py-24 bg-stone-950 px-4 sm:px-6 lg:px-8" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <FadeIn className="text-center mb-16" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-64">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-65">
          <Accordion type="single" collapsible className="w-full space-y-4" data-id="element-66">
            <AccordionItem value="item-1" className="border-stone-800 bg-stone-900 rounded-lg px-6" data-id="element-67">
              <AccordionTrigger className="text-left text-lg font-medium text-white hover:text-amber-400 py-6" data-id="element-68">
                ¿Funciona si lo hago en el móvil?
              </AccordionTrigger>
              <AccordionContent className="text-stone-400 text-base pb-6 leading-relaxed" data-id="element-69">
                No, la luz azul y las notificaciones son contraproducentes; el
                contacto físico del lápiz es clave para la descarga motora.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border-stone-800 bg-stone-900 rounded-lg px-6" data-id="element-70">
              <AccordionTrigger className="text-left text-lg font-medium text-white hover:text-amber-400 py-6" data-id="element-71">
                ¿Tengo que saber escribir bien?
              </AccordionTrigger>
              <AccordionContent className="text-stone-400 text-base pb-6 leading-relaxed" data-id="element-72">
                En absoluto, puedes usar palabras sueltas o garabatos; es un
                proceso privado de limpieza mental.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border-stone-800 bg-stone-900 rounded-lg px-6" data-id="element-73">
              <AccordionTrigger className="text-left text-lg font-medium text-white hover:text-amber-400 py-6" data-id="element-74">
                ¿Cuánto tiempo toma realmente?
              </AccordionTrigger>
              <AccordionContent className="text-stone-400 text-base pb-6 leading-relaxed" data-id="element-75">
                Una vez dominas el protocolo P.A.U., toma entre 3 y 5 minutos
                exactos.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </FadeIn>
      </div>
    </section>;
}